var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconmaterialCall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-call",
    "data-name": "Icon material-call",
    d: "M8.522,13.156a16.832,16.832,0,0,0,7.322,7.322l2.444-2.444a1.1,1.1,0,0,1,1.133-.267,12.674,12.674,0,0,0,3.967.633A1.114,1.114,0,0,1,24.5,19.511v3.878A1.114,1.114,0,0,1,23.389,24.5,18.887,18.887,0,0,1,4.5,5.611,1.114,1.114,0,0,1,5.611,4.5H9.5a1.114,1.114,0,0,1,1.111,1.111,12.623,12.623,0,0,0,.633,3.967,1.115,1.115,0,0,1-.278,1.133L8.522,13.156Z",
    transform: "translate(-4.5 -4.5)",
    fill: "#4b4b4b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconmaterialCall);
export default __webpack_public_path__ + "static/media/Icon material-call.c9ced1dc3794f9adb07cdc9f2ae94ff1.svg";
export { ForwardRef as ReactComponent };